module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-our-team page-inner"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "form_patient"
  }, [_c('Header'), _c('div', {
    staticClass: "service-inner inner-container"
  }, [_c('div', {
    staticClass: "patient-section our-team-section"
  }, [_c('h2', {
    staticClass: "black_color",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.title)
    }
  }), _c('hr'), _c('h5', [_c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.sub_title)
    }
  })]), _c('div', {
    staticClass: "team-outer-wrap"
  }, _vm._l((_vm.props.acf.our_team_list), function(OurTeam) {
    return _c('div', {
      staticClass: "team-list"
    }, [_c('div', {
      staticClass: "team-left"
    }, [_c('img', {
      attrs: {
        "src": OurTeam.image
      }
    }), (OurTeam.image_2) ? _c('img', {
      staticStyle: {
        "margin-top": "5vw"
      },
      attrs: {
        "src": OurTeam.image_2
      }
    }) : _vm._e(), _c('p', {
      domProps: {
        "innerHTML": _vm._s(OurTeam.image_2_caption)
      }
    })]), _c('div', {
      staticClass: "team-right"
    }, [_c('h2', {
      domProps: {
        "innerHTML": _vm._s(OurTeam.title)
      }
    }), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(OurTeam.designation)
      }
    }), _c('p', {
      domProps: {
        "innerHTML": _vm._s(OurTeam.content)
      }
    })])])
  }))])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfecd020","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/our-team/our-team.pug
// module id = 553
// module chunks = 1